import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";

import KogBoxGridMultiline, { IOptionGridMultiline } from "@/main/components/shared/boxGridMultiline/boxGridMultiline";
import * as SP from "@/main/components/shared/styles";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { getTranslateByFullKey, getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";
import KogModalSideComponent from "@/main/components/modal/ModalSide";
import PurchaseCriteriaModal from "@/main/components/shared/purchaseCriteriaModal/purchaseCriteriaModal";
import BlackListInfo from "@/main/components/shared/blackListInfo";
import MySuppliersInfo from "@/main/components/shared/mySuppliersInfo";
import Button from "@/main/components/shared/button/button";
import { useNavigate } from "react-router-dom";
import {
	directAssignCriteriaApi,
	parameterApi,
	partTypePerPartApi,
	prioritySupplierApi,
	purchaseCriteriaApi,
} from "@/main/api";
import { PurchaseCriteriaResponse } from "@/main/models/response/purchaseCriteriaResponse";
import { toast } from "react-toastify";
import { ParameterTypesResponse } from "@/main/models/response/parameterTypesResponse";
import { checkParametersChange } from "./utils";
import { resetReducerParameterTypeValue } from "@/main/store/parameterTypeValue";
import { ParameterTypeValueEnum } from "@/main/services/enum/ParameterTypeValueEnum";
import * as S from "./styles";
import PrioritySuppliersModal from "../../../prioritySuppliersModal/prioritySuppliersModal";
import { PrioritySuppliersResponse } from "@/main/models/response/PrioritySuppliersResponse";
import { formatPercentage } from "@/main/services/utilsNumber";
import { Controls } from "@/main/services/constants/constantsControl";
import { userIsAdmin, userIsBodyshop, userIsInsurer } from "@/main/services/utilsUser";
import SectionParameter from "./sectionParameter/sectionParameter";
import { PartTypePerPartResponse } from "@/main/models/response/partTypePerPartResponse";
import PartTypePerPartModal from "../../../partTypePerPartModal/partTypePerPartModal";
import { resetReducerPosition } from "@/main/store/position";
import { resetReducerCategory } from "@/main/store/category";
import { resetReducerSubcategory } from "@/main/store/subcategory";
import { resetReducerPartType } from "@/main/store/partType";
import {
	IInsurerRegisterForm,
	useInsurerRegisterContext,
} from "@/main/screens/registration/insurer/insurerRegisterScreen/context";
import ManufacturerReducer from "@/main/store/vehicle/manufacturer/manufacturerReducer";
import { useFormContext } from "react-hook-form";
import { SaveSupplierCompanyRelationRequest } from "@/main/models/request";
import { useSupplierTypeReducer } from "@/main/store/supplierType";
import { useManufacturerReducer } from "@/main/store/vehicle/manufacturer";
import { useReasonReducer } from "@/main/store/reason";
import { useDistributionRegionReducer } from "@/main/store/distributionRegion";
import DirectAssignCriteriaInfo from "../../../directAssignCriteriaInfo/directAssignCriteriaInfo";
import useAsyncModalConfirmReason from "@/main/components/shared/asyncModalConfirmReason/asyncModalConfirmReason";
import { ReasonTypeEnum } from "@/main/services/enum/ReasonEnum";
import { toBase64 } from "@/main/services/utilsFile";

interface ITabSettingRegister {
	guidInsurer: string | null;
	guidBodyshop: string | null;
	purchaseCriteria: PurchaseCriteriaResponse[];
	prioritySuppliers: PrioritySuppliersResponse[];
	dataParameterTypes: ParameterTypesResponse[];
	onSubmitInsurerEdit: (data: IInsurerRegisterForm) => void;
	insurerFormData: IInsurerRegisterForm;
	blacklistAndMySuppliersDeleteItem: SaveSupplierCompanyRelationRequest[];
	setBlacklistAndMySuppliersDeleteItem: React.Dispatch<React.SetStateAction<SaveSupplierCompanyRelationRequest[]>>;
	setDataParameterTypes: React.Dispatch<React.SetStateAction<ParameterTypesResponse[]>>;
	partTypePerPart: PartTypePerPartResponse[];
}
export function TabSettingRegister({
	guidInsurer = null,
	guidBodyshop = null,
	purchaseCriteria = [],
	prioritySuppliers = [],
	dataParameterTypes = [],
	setDataParameterTypes,
	partTypePerPart = [],
	onSubmitInsurerEdit,
	insurerFormData,
	blacklistAndMySuppliersDeleteItem,
	setBlacklistAndMySuppliersDeleteItem,
}: ITabSettingRegister) {
	const lowercaseValues = (parameterTypes: ParameterTypesResponse[]) => {
		return parameterTypes.map((data) => ({
			...data,
			parameters: data.parameters.map((parameter) => {
				if (data.idParameterTypeValue === ParameterTypeValueEnum.Boolean && !!parameter.value) {
					return {
						...parameter,
						value: parameter.value.toLowerCase(),
					};
				} else {
					return {
						...parameter,
					};
				}
			}),
		}));
	};

	const dispatch = useDispatch();
	const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();
	const methods = useFormContext<IInsurerRegisterForm>();
	useInsurerRegisterContext();
	const watcherCountry = methods.watch("country");
	const manufacturerReducer = useManufacturerReducer();
	const [dataUserParameters, setDataUserParameters] = useState<ParameterTypesResponse[]>(
		lowercaseValues(dataParameterTypes),
	);
	const [dataUserPurchaseCriteria, setDataUserPurchaseCriteria] =
		useState<PurchaseCriteriaResponse[]>(purchaseCriteria);
	const [dataUserPrioritySuppliers, setDataUserPrioritySuppliers] =
		useState<PrioritySuppliersResponse[]>(prioritySuppliers);
	const [dataUserPartTypePerPart, setDataUserPartTypePerPart] = useState<PartTypePerPartResponse[]>(partTypePerPart);
	const [dataParametersScreen, setDataParametersScreen] = useState<ParameterTypesResponse[]>(
		lowercaseValues(dataParameterTypes),
	);
	const [dataPurchaseCriteria, setDataPurchaseCriteria] = useState<IOptionGridMultiline[]>([]);
	const [dataPrioritySuppliers, setDataPrioritySuppliers] = useState<IOptionGridMultiline[]>([]);
	const [dataPartTypePerPart, setDataPartTypePerPart] = useState<IOptionGridMultiline[]>([]);
	const [deletePurchaseCriteria, setDeletePurchaseCriteria] = useState<string[]>([]);
	const [deletePrioritySupplier, setDeletePrioritySupplier] = useState<string[]>([]);
	const [deletePartTypePerPart, setDeleteDataPartTypePerPart] = useState<string[]>([]);
	const [deleteDirectAssignCriteria, setDeleteDirectAssignCriteria] = useState<string[]>([]);
	const [renderModal, setRenderModal] = useState<React.ReactNode>([]);
	const [open, setOpen] = useState<boolean>(false);
	const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

	const rowHeadersPurchaseCriteria = [
		getTranslateByKey("information.make"),
		getTranslateByKey("information.ageStart"),
		getTranslateByKey("information.ageEnd"),
		getTranslateByKey("information.claimType"),
		getTranslateByKey("information.partTypes"),
		<div key="5" style={{ textAlign: "center" }}>
			{getTranslateByKey("information.actions")}
		</div>,
	];

	const rowHeadersPrioritySuppliers = [
		getTranslateByKey("information.initialZipCode"),
		getTranslateByKey("information.finalZipCode"),
		getTranslateByKey("information.partTypes"),
		getTranslateByKey("information.supplier"),
		getTranslateByKey("information.advantageFactor"),
		<div key="5" style={{ textAlign: "center" }}>
			{getTranslateByKey("information.actions")}
		</div>,
	];

	const rowHeadersPartTypePerPart = [
		getTranslateByFullKey("t.nah.quoteCard.category"),
		getTranslateByFullKey("t.nah.quoteCard.subCategory"),
		getTranslateByFullKey("t.nah.quoteCard.partName"),
		getTranslateByKey("information.position"),
		getTranslateByKey("information.partTypes"),
		<div key="5" style={{ textAlign: "center" }}>
			{getTranslateByKey("information.actions")}
		</div>,
	];

	const formatedPurchaseCriteria = () => {
		if (dataUserPurchaseCriteria.length === 0) {
			return setDataPurchaseCriteria([]);
		}
		const parametersGrid: IOptionGridMultiline[] = [];
		dataUserPurchaseCriteria.map((data) => {
			parametersGrid.push({
				id: data.guids[0],
				elements: [
					{
						content: data.vehicleManufacturerName,
						width: "14%",
					},
					{
						content: data.yearStart,
						width: "13%",
					},
					{
						content: data.yearEnd,
						width: "13%",
					},
					{
						content: data.claimTypes,
						width: "20%",
					},
					{
						content: data.partTypes,
						width: "30%",
					},
					{
						content: (
							<S.TextValue cursor="pointer" id={`id-register-btn-deletePurchaseCriteria`}>
								<CloseIcon onClick={() => handleDeletePurchaseCriteria(data.guids)} />
							</S.TextValue>
						),
						width: "10%",
					},
				],
			});
			setDataPurchaseCriteria(parametersGrid);
		});
	};

	const formatedPrioritySuppliers = () => {
		if (dataUserPrioritySuppliers.length === 0) {
			return setDataPrioritySuppliers([]);
		}
		const parametersGrid: IOptionGridMultiline[] = [];
		dataUserPrioritySuppliers.map((data) => {
			parametersGrid.push({
				id: data.guidPrioritySupplier,
				elements: [
					{
						content: data.zipCodeStart,
						width: "14%",
					},
					{
						content: data.zipCodeEnd,
						width: "14%",
					},
					{
						content: data.partType,
						width: "14%",
					},
					{
						content: data.supplier,
						width: "28%",
					},
					{
						content: formatPercentage(data.advantageRate),
						width: "14%",
					},
					{
						content: (
							<S.TextValue cursor="pointer" id={`id-register-btn-deletePrioritySuppliers`}>
								<CloseIcon onClick={() => handleDeletePrioritySuppliers(data.guidPrioritySupplier)} />
							</S.TextValue>
						),
						width: "10%",
					},
				],
			});
			setDataPrioritySuppliers(parametersGrid);
		});
	};

	function handleDeletePurchaseCriteria(guids: string[]) {
		setDataUserPurchaseCriteria((prevState) => {
			for (let i = 0; i < prevState.length; i++) {
				const guidsPrevState = prevState[i].guids;

				if (guidsPrevState.length !== guids.length) {
					continue;
				}

				let arraysEquals = true;
				for (let j = 0; j < guidsPrevState.length; j++) {
					if (guidsPrevState[j] !== guids[j]) {
						arraysEquals = false;
						break;
					}
					setDeletePurchaseCriteria((prev) => [...prev, guids[j]]);
				}

				if (arraysEquals) {
					prevState.splice(i, 1);
				}
			}
			return [...prevState];
		});
	}

	function handleDeletePrioritySuppliers(guidDelete: string) {
		setDataUserPrioritySuppliers((prevState) => {
			let isDeleted = false;
			for (let i = 0; i < prevState.length; i++) {
				if (isDeleted) {
					break;
				}

				let arraysIguais = true;
				if (prevState[i].guidPrioritySupplier !== guidDelete) {
					arraysIguais = false;
					continue;
				}
				setDeletePrioritySupplier((prev) => [...prev, guidDelete]);
				isDeleted = true;

				if (arraysIguais) {
					prevState.splice(i, 1);
				}
			}
			return [...prevState];
		});
	}

	const formatedPartTypePerPart = () => {
		if (dataUserPartTypePerPart.length === 0) {
			return setDataPartTypePerPart([]);
		}
		const parametersGrid: IOptionGridMultiline[] = [];
		dataUserPartTypePerPart.map((data) => {
			parametersGrid.push({
				id: data.guidPartTypePerPart,
				elements: [
					{
						content: data.category,
						width: "14%",
					},
					{
						content: data.subCategory,
						width: "14%",
					},
					{
						content: data.partName,
						width: "14%",
					},
					{
						content: data.position,
						width: "28%",
					},
					{
						content: data.partType,
						width: "14%",
					},
					{
						content: (
							<S.TextValue cursor="pointer" id={`id-register-btn-deletePrioritySuppliers`}>
								<CloseIcon onClick={() => handleDeletePartTypePerPart(data.guidPartTypePerPart)} />
							</S.TextValue>
						),
						width: "10%",
					},
				],
			});
			setDataPartTypePerPart(parametersGrid);
		});
	};

	function handleDeletePartTypePerPart(guidDelete: string) {
		setDataUserPartTypePerPart((prevState) => {
			let isDeleted = false;
			for (let i = 0; i < prevState.length; i++) {
				if (isDeleted) {
					break;
				}

				let arraysIguais = true;
				if (prevState[i].guidPartTypePerPart !== guidDelete) {
					arraysIguais = false;
					continue;
				}
				setDeleteDataPartTypePerPart((prev) => [...prev, guidDelete]);
				isDeleted = true;

				if (arraysIguais) {
					prevState.splice(i, 1);
				}
			}
			return [...prevState];
		});
	}

	const [formFiltersBlacklist, setFormFiltersBlacklist] = useState<any | null>(null);
	const [formFiltersFavorite, setFormFiltersFavorite] = useState<any | null>(null);
	const supplierTypeReducer = useSupplierTypeReducer();
	const reasonReducer = useReasonReducer();
	const distributionRegionReducer = useDistributionRegionReducer();

	useEffect(() => {
		formatedPurchaseCriteria();
	}, [dataUserPurchaseCriteria]);

	useEffect(() => {
		formatedPrioritySuppliers();
	}, [dataUserPrioritySuppliers]);

	useEffect(() => {
		formatedPartTypePerPart();
	}, [dataUserPartTypePerPart]);

	function resetReducers() {
		// dispatch part type per part modal
		dispatch(resetReducerPosition());
		dispatch(resetReducerCategory());
		dispatch(resetReducerSubcategory());
		dispatch(resetReducerPartType());
	}

	function closeModal() {
		setRenderModal([]);
		setOpen(false);
		resetReducers();
	}
	function openModal(
		nameProp: "purchaseCriteria" | "prioritySuppliers" | "partTypePerPart" | "blackListInfo" | "mySuppliersInfo",
	) {
		if (nameProp === "purchaseCriteria") {
			setRenderModal(
				<PurchaseCriteriaModal
					guidBodyShop={guidBodyshop}
					guidInsurer={guidInsurer}
					dataPurchaseCriteriaGrid={dataUserPurchaseCriteria}
					setPurchaseCriteriaGrid={setDataUserPurchaseCriteria}
					setOpen={setOpen}
				/>,
			);
			setOpen(true);
		}
		if (nameProp === "prioritySuppliers") {
			setRenderModal(
				<PrioritySuppliersModal
					guidBodyShop={guidBodyshop}
					guidInsurer={guidInsurer}
					dataPrioritySuppliersGrid={dataUserPrioritySuppliers}
					setPrioritySuppliersGrid={setDataUserPrioritySuppliers}
					setOpen={setOpen}
				/>,
			);
			setOpen(true);
		}
		if (nameProp === "partTypePerPart") {
			setRenderModal(
				<PartTypePerPartModal
					guidBodyShop={guidBodyshop}
					guidInsurer={guidInsurer}
					dataPartTypePerPart={null}
					dataPartTypePerPartGrid={dataUserPartTypePerPart}
					setPartTypePerPartGrid={setDataUserPartTypePerPart}
					closeModal={closeModal}
				/>,
			);
			setOpen(true);
		}
		if (nameProp === "blackListInfo") {
			setRenderModal(
				<BlackListInfo
					reasonReducer={reasonReducer}
					distributionRegionReducer={distributionRegionReducer}
					supplierTypeReducer={supplierTypeReducer}
					manufacturerReducer={ManufacturerReducer}
					watcherCountry={watcherCountry}
					guidInsurer={guidInsurer}
					formFilters={formFiltersBlacklist}
					setFormFilters={setFormFiltersBlacklist}
					setBlacklistAndMySuppliersDeleteItem={setBlacklistAndMySuppliersDeleteItem}
					blacklistAndMySuppliersDeleteItem={blacklistAndMySuppliersDeleteItem}
				/>,
			);
			setOpen(true);
		}

		if (nameProp === "mySuppliersInfo") {
			setRenderModal(
				<MySuppliersInfo
					distributionRegionReducer={distributionRegionReducer}
					supplierTypeReducer={supplierTypeReducer}
					manufacturerReducer={ManufacturerReducer}
					watcherCountry={watcherCountry}
					guidInsurer={guidInsurer}
					formFilters={formFiltersFavorite}
					setFormFilters={setFormFiltersFavorite}
					setBlacklistAndMySuppliersDeleteItem={setBlacklistAndMySuppliersDeleteItem}
					blacklistAndMySuppliersDeleteItem={blacklistAndMySuppliersDeleteItem}
				/>,
			);
			setOpen(true);
		}
	}

	async function handleSaveSettings() {
		const hasAnyChange =
			checkParametersChange(dataParametersScreen, dataUserParameters) ||
			deletePurchaseCriteria.length !== 0 ||
			deleteDirectAssignCriteria.length !== 0 ||
			deletePrioritySupplier.length !== 0 ||
			deletePartTypePerPart.length !== 0;

		let resultConfirm = null;
		let filesRequest = undefined;

		if (hasAnyChange) {
			resultConfirm = await getConfirmationReason(
				getTranslateByKey("information.confirmChangeTitle"),
				ReasonTypeEnum.ChangeCompany,
			);

			if (!resultConfirm.confirmed) {
				setLoadingSubmit(false);
				return;
			}

			if (resultConfirm.files && resultConfirm.files.length > 0) {
				filesRequest = await Promise.all(
					resultConfirm.files.map(async (item) => {
						const base64DataUrl = await toBase64(item);
						return {
							fileName: item.name,
							contentType: item.type,
							fileBase64: base64DataUrl as string,
						};
					}),
				);
			}
		}

		setLoadingSubmit(true);
		if (checkParametersChange(dataParametersScreen, dataUserParameters)) {
			const requestSaveParameters: {
				guid: string;
				value: string;
			}[] = [];
			dataParametersScreen.map((x: any) => {
				x.parameters.map((y: any) => {
					return requestSaveParameters.push({
						guid: y.guid,
						value: y.value,
					});
				});
			});

			const parameterPayload = {
				parameters: requestSaveParameters,
				changeJustification: {
					guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
					reasonDescription: resultConfirm?.observation || null,
					filesUpload: filesRequest,
				},
			};

			try {
				await parameterApi.saveParameter(parameterPayload);
				toast.success(getTranslateByKey("information.parametersSavedSuccessfully"));
				dispatch(resetReducerParameterTypeValue());
				setDataParameterTypes(dataParametersScreen);
				setDataUserParameters(dataParametersScreen);
				setLoadingSubmit(false);
			} catch {
			} finally {
				setLoadingSubmit(false);
			}
		}
		if (deletePurchaseCriteria.length !== 0) {
			setLoadingSubmit(true);
			const purchaseCriteriaPayload = {
				guidsPurchaseCriteria: deletePurchaseCriteria,
				changeJustification: {
					guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
					reasonDescription: resultConfirm?.observation || null,
					filesUpload: filesRequest,
				},
			};

			purchaseCriteriaApi
				.deletePurchaseCriteria(purchaseCriteriaPayload)
				.then(() => {
					toast.success(getTranslateByKey("purchaseCriteria.purchaseCriteriaSavedSuccessfully"));
					setDeletePurchaseCriteria([]);
				})
				.finally(() => setLoadingSubmit(false));
		}

		if (deleteDirectAssignCriteria.length !== 0) {
			setLoadingSubmit(true);
			const directAssignPayload = {
				guidsDirectAssignCriteria: deleteDirectAssignCriteria,
				changeJustification: {
					guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
					reasonDescription: resultConfirm?.observation || null,
					filesUpload: filesRequest,
				},
			};

			directAssignCriteriaApi
				.deleteDirectAssignCriteria(directAssignPayload)
				.then(() => {
					toast.success(getTranslateByKey("directAssignCriteria.directAssignCriteriaSavedSuccessfully"));
					setDeletePurchaseCriteria([]);
				})
				.finally(() => setLoadingSubmit(false));
		}

		if (deletePrioritySupplier.length !== 0) {
			setLoadingSubmit(true);
			const prioritySupplierPayload = {
				guidsPrioritySuppliers: deletePrioritySupplier,
				changeJustification: {
					guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
					reasonDescription: resultConfirm?.observation || null,
					filesUpload: filesRequest,
				},
			};

			prioritySupplierApi
				.deletePrioritySupplier(prioritySupplierPayload)
				.then(() => {
					toast.success(getTranslateByKey("information.prioritySuppliersSavedSuccessfully"));
					setDeletePrioritySupplier([]);
				})
				.finally(() => setLoadingSubmit(false));
		}

		if (deletePartTypePerPart.length !== 0) {
			setLoadingSubmit(true);
			const partTypePayload = {
				guidsPartTypePerPart: deletePartTypePerPart,
				changeJustification: {
					guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
					reasonDescription: resultConfirm?.observation || null,
					filesUpload: filesRequest,
				},
			};

			partTypePerPartApi
				.deletePartTypePerPart(partTypePayload)
				.then(() => {
					toast.success(getTranslateByKey("information.partTypePerPartSavedSuccessfully"));
					setDeleteDataPartTypePerPart([]);
				})
				.finally(() => setLoadingSubmit(false));
		}

		if (blacklistAndMySuppliersDeleteItem.length !== 0) {
			setLoadingSubmit(true);
			try {
				await onSubmitInsurerEdit(insurerFormData);
				setBlacklistAndMySuppliersDeleteItem([]);
			} catch {
				toast.error(getTranslateByKey("error.default"));
			} finally {
				setLoadingSubmit(false);
				setFormFiltersFavorite(null);
				setFormFiltersBlacklist(null);
			}
		}
	}

	return (
		<S.Container>
			<S.ContainerSection>
				<SP.HeaderText>{getTranslateByKey("information.registerInsurerParameters")}</SP.HeaderText>
				<SectionParameter
					dataParameterAPI={dataParameterTypes}
					dataParametersScreen={dataParametersScreen}
					setDataParametersScreen={setDataParametersScreen}
				/>
			</S.ContainerSection>

			<S.ContainerSection>
				<S.ContainerTitle>
					<SP.HeaderText>{getTranslateByKey("information.purchaseCriteria")}</SP.HeaderText>
					<SecondaryButton
						id="id-register-btn-addPurchaseCriteria"
						style={{ padding: ".2rem .8rem", margin: ".5rem 0 0 .8rem" }}
						onClick={() => openModal("purchaseCriteria")}
					>
						{getTranslateByKey("information.addCriteria")}
					</SecondaryButton>
				</S.ContainerTitle>
				{dataPurchaseCriteria.length > 0 && (
					<KogBoxGridMultiline
						rowHeaders={rowHeadersPurchaseCriteria}
						options={dataPurchaseCriteria}
						sizeCell="medium"
					/>
				)}
			</S.ContainerSection>

			{isShowControlByElementId(Controls.IdPrioritySupplier) &&
				(userIsAdmin() || userIsBodyshop() || userIsInsurer()) && (
					<S.ContainerSection>
						<S.ContainerTitle>
							<SP.HeaderText>{getTranslateByKey("information.prioritySuppliers")}</SP.HeaderText>
							<SecondaryButton
								id="id-register-btn-addPrioritySuppliers"
								style={{ padding: ".2rem .8rem", margin: ".5rem 0 0 .8rem" }}
								onClick={() => openModal("prioritySuppliers")}
							>
								{getTranslateByKey("information.addPrioritySuppliers")}
							</SecondaryButton>
						</S.ContainerTitle>
						{dataPrioritySuppliers.length > 0 && (
							<KogBoxGridMultiline
								rowHeaders={rowHeadersPrioritySuppliers}
								options={dataPrioritySuppliers}
								sizeCell="medium"
							/>
						)}
					</S.ContainerSection>
				)}
			{(userIsAdmin() || userIsBodyshop() || userIsInsurer()) && (
				<S.ContainerSection>
					<S.ContainerTitle>
						<SP.HeaderText>{getTranslateByKey("information.partTypePerPart")}</SP.HeaderText>
						<SecondaryButton
							id="id-register-btn-addPartTypePerPart"
							style={{ padding: ".2rem .8rem", margin: ".5rem 0 0 .8rem" }}
							onClick={() => openModal("partTypePerPart")}
						>
							{getTranslateByKey("information.addPart")}
						</SecondaryButton>
					</S.ContainerTitle>
					{dataPartTypePerPart.length > 0 && (
						<KogBoxGridMultiline
							rowHeaders={rowHeadersPartTypePerPart}
							options={dataPartTypePerPart}
							sizeCell="medium"
						/>
					)}
				</S.ContainerSection>
			)}
			{insurerFormData && (
				<>
					<BlackListInfo
						reasonReducer={reasonReducer}
						distributionRegionReducer={distributionRegionReducer}
						supplierTypeReducer={supplierTypeReducer}
						manufacturerReducer={manufacturerReducer}
						watcherCountry={watcherCountry}
						guidInsurer={guidInsurer}
						formFilters={formFiltersBlacklist}
						setFormFilters={setFormFiltersBlacklist}
						setBlacklistAndMySuppliersDeleteItem={setBlacklistAndMySuppliersDeleteItem}
						blacklistAndMySuppliersDeleteItem={blacklistAndMySuppliersDeleteItem}
					/>

					<MySuppliersInfo
						distributionRegionReducer={distributionRegionReducer}
						supplierTypeReducer={supplierTypeReducer}
						manufacturerReducer={manufacturerReducer}
						watcherCountry={watcherCountry}
						guidInsurer={guidInsurer}
						formFilters={formFiltersFavorite}
						setFormFilters={setFormFiltersFavorite}
						setBlacklistAndMySuppliersDeleteItem={setBlacklistAndMySuppliersDeleteItem}
						blacklistAndMySuppliersDeleteItem={blacklistAndMySuppliersDeleteItem}
						isInsurerView
					/>

					<DirectAssignCriteriaInfo
						deleteDirectAssignCriteria={deleteDirectAssignCriteria}
						setDeleteDirectAssignCriteria={setDeleteDirectAssignCriteria}
						guidInsurer={guidInsurer}
					/>
				</>
			)}

			<FootersButtons
				deletePurchaseCriteria={deletePurchaseCriteria}
				deletePrioritySupplier={deletePrioritySupplier}
				deletePartTypePerPart={deletePartTypePerPart}
				deleteDirectAssignCriteria={deleteDirectAssignCriteria}
				blacklistAndMySuppliersDeleteItem={blacklistAndMySuppliersDeleteItem}
				handleSaveSettings={handleSaveSettings}
				loadingSubmit={loadingSubmit}
				hasChangeParameter={checkParametersChange(dataParametersScreen, dataUserParameters)}
			/>

			<KogModalSideComponent open={open} closeModal={() => closeModal()}>
				{renderModal || ""}
			</KogModalSideComponent>
			<ModalConfirmationReason />
		</S.Container>
	);
}

interface IFootersButtons {
	deletePurchaseCriteria: string[];
	deletePrioritySupplier: string[];
	deletePartTypePerPart: string[];
	deleteDirectAssignCriteria: string[];
	blacklistAndMySuppliersDeleteItem: SaveSupplierCompanyRelationRequest[];
	handleSaveSettings: () => void;
	loadingSubmit: boolean;
	hasChangeParameter: boolean;
}
export function FootersButtons({
	deletePurchaseCriteria,
	deletePrioritySupplier,
	deletePartTypePerPart,
	deleteDirectAssignCriteria,
	blacklistAndMySuppliersDeleteItem,
	handleSaveSettings,
	loadingSubmit,
	hasChangeParameter,
}: IFootersButtons) {
	const navigate = useNavigate();

	function handleBack() {
		navigate(-1);
	}

	const isDisabledSave =
		hasChangeParameter ||
		deletePurchaseCriteria.length !== 0 ||
		deletePrioritySupplier.length !== 0 ||
		deleteDirectAssignCriteria.length !== 0 ||
		(deletePartTypePerPart?.length ?? 0) !== 0 ||
		(blacklistAndMySuppliersDeleteItem?.length ?? 0) !== 0;

	return (
		<S.FooterButtons>
			<SecondaryButton type="button" onClick={handleBack} id="id-insurerBodyshopTabSettings-button-back">
				{getTranslateByKey("information.back")}
			</SecondaryButton>
			<Button
				type="submit"
				onClick={handleSaveSettings}
				disabled={loadingSubmit || !isDisabledSave}
				id="id-insurerBodyshopTabSettings-button-save"
				isLoading={loadingSubmit}
			>
				{getTranslateByKey("information.save")}
			</Button>
		</S.FooterButtons>
	);
}
